<template>
  <div class="container-dark" id="partner">
    <div class="container">
      <h1 class="headline-light mb-4 bebas">Unsere Partner</h1>
      <div class="partner-images">
        <div class="logo">
          <img
            src="../assets/partner-stauder.png"
            alt="Logo von Stauder"
          />
        </div>
        
        <div class="logo">
          <img
            src="../assets/partner/sinalco.png"
            alt="Logo von Sinalco"
          />
        </div>

        <div class="logo">
          <img
            src="../assets/partner/matchday.png"
            alt="Logo von Matchday"
          />
        </div>

        <div class="logo">
          <img
            class="sinalco"
            src="../assets/partner/reviersport.png"
            alt="Logo von Reviersport"
          />
        </div>

        <div class="logo">
          <img
            class="sinalco"
            src="../assets/partner/sportwetten.jpg"
            alt="Logo von Sportwetten"
          />
        </div>

        <div class="logo">
          <img
            class="sinalco"
            src="../assets/partner/exact.png"
            alt="Logo von Exact"
          />
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss" scoped>
.partner-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 equal columns */
  gap: 2rem;
  align-items: center; /* vertical alignment */
  justify-items: center; /* horizontal alignment */ 
}

.logo img {
  max-width: 100%;
  max-height: 60px; /* optional: constrain height */
  object-fit: contain;
}


</style>
